import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "./ui/button";

export default function Navbar() {
    const location = useLocation();

    return (
        <nav className="bg-card text-card-foreground border-b border-border p-4 shadow-sm">
            <div className="container mx-auto flex justify-between items-center">
                <Link to="/transaction" className="text-xl font-bold tracking-tight text-primary">
                    <span className="text-red-600">Milli</span>pointAdmin
                </Link>
                <div className="flex space-x-2">
                    <Button
                        asChild
                        variant={location.pathname === "/transaction" ? "default" : "ghost"}
                        className={location.pathname === "/transaction" ? "bg-red-600 hover:bg-red-700 text-white" : "hover:text-red-600 hover:bg-red-600/10"}
                    >
                        <Link to="/transaction">
                            Transaction
                        </Link>
                    </Button>
                    <Button
                        asChild
                        variant={location.pathname === "/price" ? "default" : "ghost"}
                        className={location.pathname === "/price" ? "bg-red-600 hover:bg-red-700 text-white" : "hover:text-red-600 hover:bg-red-600/10"}
                    >
                        <Link to="/price">
                            Price
                        </Link>
                    </Button>
                    <Button
                        asChild
                        variant={location.pathname === "/stats" ? "default" : "ghost"}
                        className={location.pathname === "/stats" ? "bg-red-600 hover:bg-red-700 text-white" : "hover:text-red-600 hover:bg-red-600/10"}
                    >
                        <Link to="/stats">
                            Stats
                        </Link>
                    </Button>
                </div>
            </div>
        </nav>
    );
}